import { render, staticRenderFns } from "./AddPhenomenonGroup.vue?vue&type=template&id=7806fd75&"
import script from "./AddPhenomenonGroup.vue?vue&type=script&lang=ts&"
export * from "./AddPhenomenonGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports